import { AfterViewInit, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import * as Highcharts from 'highcharts';

declare var require: any;
const sankey = require('highcharts/modules/sankey');
const organization = require('highcharts/modules/organization');

sankey(Highcharts);
organization(Highcharts);

@Component({
  selector: 'app-dataflow-graph',
  templateUrl: './dataflow-graph.component.html',
  styleUrls: ['./dataflow-graph.component.scss']
})
export class DataflowGraphComponent implements AfterViewInit {

  @ViewChild('dataflowChart', { static: false }) orgChartContainer;
  @Output() processSelected = new EventEmitter<string>();

  ngAfterViewInit(): void {
    const options: any = {
      chart: {
        height: 750,
        inverted: true
      },
      title: {
        text: 'IoTsens dataflow'
      },
      accessibility: {
        point: {
          descriptionFormatter(point: any): string {
            const nodeName = point.toNode.name;
            const nodeId = point.toNode.id;
            const nodeDesc = nodeName === nodeId ? nodeName : nodeName + ', ' + nodeId;
            const parentDesc = point.fromNode.id;
            return (
              point.index + '. ' + nodeDesc + ', reports to ' + parentDesc + '.'
            );
          }
        }
      },
      series: [{
        type: 'organization',
        name: 'Process',
        keys: ['from', 'to'],
        cursor: 'pointer',
        data: [
          ['iotsens-ingestion-dispatcher', 'iotsens-ingestion-decoder'],
          ['iotsens-ingestion-decoder', 'iotsens-knowledge-expressions'],
          ['iotsens-knowledge-expressions', 'iotsens-knowledge-persistence'],
          ['iotsens-knowledge-persistence', 'iotsens-knowledge-lastvalues'],
          ['iotsens-knowledge-persistence', 'iotsens-knowledge-dispatcher'],
          ['iotsens-knowledge-dispatcher', 'iotsens-knowledge-ruleengine'],
          ['iotsens-knowledge-ruleengine', 'iotsens-knowledge-subscriptions'],
          ['iotsens-knowledge-dispatcher', 'iotsens-knowledge-subscriptions'],
          ['iotsens-knowledge-subscriptions', 'facsa-estimations'],
          ['iotsens-knowledge-subscriptions', 'google-geolocation']
        ],
        nodes: [{
          id: 'iotsens-ingestion-dispatcher',
          color: 'transparent'
        }, {
          id: 'iotsens-knowledge-expressions',
          color: 'transparent'
        }, {
          id: 'iotsens-ingestion-decoder',
          color: 'transparent'
        }, {
          id: 'ingestion-une82326-hub-0238-v2',
          color: 'transparent'
        }, {
          id: 'iotsens-knowledge-persistence',
          color: 'transparent'
        }, {
          id: 'iotsens-knowledge-lastvalues',
          color: 'transparent'
        }, {
          id: 'iotsens-knowledge-dispatcher',
          color: 'transparent'
        }, {
          id: 'iotsens-knowledge-ruleengine',
          color: 'transparent'
        }, {
          id: 'iotsens-knowledge-subscriptions',
          color: 'transparent'
        }, {
          id: 'facsa-estimations',
          color: 'transparent'
        }, {
          id: 'google-geolocation',
          color: 'transparent'
        }],
        colorByPoint: false,
        dataLabels: {
          color: 'black'
        },
        nodeWidth: 45
      }],
      plotOptions: {
        series: {
          states: {
            hover: {
              enabled: false
            },
            inactive: {
              enabled: false
            },
            select: {
              color: '#93c5fd',
              borderColor: '#0284c7'
            }
          },
          allowPointSelect: false,
          point: {
            events: {
              click: (event) => {
                this.processSelected.emit(event.point.id);
              },
              mouseOut(): void {
                this.update({
                  color: 'transparent'
                });
              },
              mouseOver(): void {
                this.update({
                  color: '#eff6ff'
                });
              }
            }
          }
        }
      },
      tooltip: {
        enabled: false
      }
    };
    Highcharts.chart(this.orgChartContainer.nativeElement, options);
  }

}
